import { mapBackendUserToUser, User } from './User';

// MAPPER
export const meMapper = (response: any): User => mapBackendUserToUser(response.data);
